// https://vuex.vuejs.org/en/getters.html
import { Ability } from '@casl/ability'

export default {
  token: state => state.user.token,
  name: state => state.user.name,
  role: state => state.user.role,
  loading: state => state.app.loading,
  user: state => state.user,
  app: state => state.app,

  // accountDialog: state => state.app.accountDialog,
  // accountItem: state => state.app.accountItem,
  // disposalDialog: state => state.app.disposalDialog,
  // disposalItem: state => state.app.disposalItem,

  snackbar: state => state.app.snackbar,
  ability: () => {
    return new Ability([
      { action: ['read'], subject: ['all'] }
    ])
  }
}
